// The signed-in login's appearance (routes/account.py): one theme per login,
// the same on the web, the iPhone app and the Mac app. Plain calls, not
// query hooks: the sync (features/appearance) runs above the query client,
// for every role, and handles its own failures quietly.

import { apiFetch } from "@/lib/api";
import type { components } from "@/types/api.gen";

export type Appearance = components["schemas"]["Appearance"];
export type AppearanceTheme = components["schemas"]["AppearanceUpdate"]["theme"];

const PATH = "/api/account/appearance";

export function getAppearance(signal?: AbortSignal): Promise<Appearance> {
  return apiFetch<Appearance>(PATH, { signal });
}

export function setAppearance(theme: AppearanceTheme): Promise<Appearance> {
  return apiFetch<Appearance>(PATH, { method: "PUT", body: { theme } });
}
